<template>
  <button class="back-button" :class="cssClass" @click="$router.go(-1)">
    <img :src="imgsrc" alt="back" width="24" height="12">
  </button>
</template>

<script>
import WhiteArrow from '../assets/back-arrow.png'
import BlackArrow from '../assets/back-arrow-blk.png'

export default {
  name: 'back-button',
  props: {
    cssClass: String
  },
  computed: {
    imgsrc () {
      return this.cssClass === 'reverse' ? BlackArrow : WhiteArrow
    }
  }
}
</script>

<style lang="scss" scoped>
img{
  margin:auto;
}

</style>
